import { createContext } from '@change-corgi/core-react/context';

import type { UseLoadGooglePlacesReturn } from '../hooks/useLoadGooglePlaces';

// FIXME should this be a createMandatoryContext?
/** @knip-ignore */
export const {
	Context: GooglePlacesContext,
	Provider: GooglePlacesContextProvider,
	useContext: useGooglePlacesContext,
} = createContext<
	UseLoadGooglePlacesReturn | undefined,
	{
		status: 'loading' | 'loaded' | 'error';
		autocompleteService?: typeof google.maps.places.AutocompleteSuggestion;
		sessionToken?: google.maps.places.AutocompleteSessionToken;
		resetSessionToken: () => void;
	}
>(undefined, {
	name: 'GooglePlacesContext',
	processProviderProps: ({ status, autocompleteService, sessionToken, resetSessionToken }) => ({
		status,
		autocompleteService,
		sessionToken,
		resetSessionToken,
	}),
});
